import { twMerge } from 'tailwind-merge';
import { type JSX, PropsWithChildren } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export interface LoaderProps {
  isLoading?: boolean;
  isFullScreen?: boolean;
  absolutePosition?: boolean;
}

export const Loader = ({
  children,
  isLoading = false,
  isFullScreen = true,
  absolutePosition = false,
}: PropsWithChildren<LoaderProps>): JSX.Element => {
  const className = twMerge(
    'flex justify-center items-center w-full h-full backdrop-blur-[3px]',
    isFullScreen && `fixed top-0 left-0 z-2000`,
    absolutePosition && `absolute inset-0 z-2000`
  );

  return (
    <>
      {children}
      {isLoading && (
        <div test-id="loader" className={className}>
          <CircularProgress />
        </div>
      )}
    </>
  );
};
